import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette }: Theme) => ({
    root: {
      position: 'relative',
      maxWidth: 1160,
      [breakpoints.down(1024)]: {
        maxWidth: 600,
      },
    },
    topSection: {
      padding: '30px 0',
      textAlign: 'center',
    },
    topTitle: {
      display: 'block',
      fontFamily: 'Merriweather',
      fontSize: 40,
      fontWeight: 900,
      margin: 0,
      marginBottom: 16,
      color: custom.grey[3],
      lineHeight: '46px',
      [breakpoints.down(1024)]: {
        fontSize: 26,
        lineHeight: '32px',
      },
    },
    topSubtitle: {
      fontSize: 18,
      lineHeight: '22px',
      fontWeight: 400,
      color: custom.grey[17],
      marginBottom: 40,
      whiteSpace: 'pre-wrap',
      [breakpoints.down(1024)]: {
        whiteSpace: 'normal',
      },
    },
    topBoxesRow: {
      display: 'flex',
      justifyContent: 'center',
      gap: 24,
      margin: '0 auto',
      flexWrap: 'wrap',
    },
    topBox: {
      minWidth: 220,
      maxWidth: 384,
      background: palette.common.white,
      borderRadius: 16,
      padding: 24,
      flex: '1 1 260px',
      color: custom.grey[3],
    },
    topBoxIcon: {
      marginRight: 8,
      fontSize: 32,
    },
    topBoxTitle: {
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '22px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: 16,
    },
    topBoxDesc: {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 400,
      textAlign: 'left',
    },
    accordion: {
      borderTop: `solid 1px ${custom.grey[13]}`,
      padding: '24px 0',
      '&:last-child': {
        borderBottom: `solid 1px ${custom.grey[13]}`,
      },
    },
    accordionSummary: {
      background: 'none',
      border: 'none',
      outline: 'none',
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: custom.grey[3],
      fontSize: 22,
      lineHeight: '26px',
      fontWeight: 700,
      padding: 0,
    },
    sectionTitle: {
      fontFamily: 'Lato',
      fontSize: 22,
      fontWeight: 700,
      lineHeight: '26px',
      textAlign: 'left',
      margin: 0,
    },
    sectionContent: {
      padding: '0 0 16px 0',
      animation: '$fadeIn 0.2s',
    },
    qaItem: {
      color: custom.grey[3],
    },
    question: {
      padding: '24px 0',
      fontSize: 18,
      fontWeight: 700,
      lineHeight: '22px',
      margin: 0,
    },
    answer: {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 400,
      '& ul': {
        paddingLeft: 20,
        margin: 0,
      },
    },
    arrow: {
      color: custom.grey[3],
      transition: 'transform 0.2s',
      marginLeft: 8,
      '&>svg': {
        fontSize: 32,
      },
    },
    arrowOpen: {
      transform: 'rotate(180deg)',
    },
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    backToTop: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 40,
    },
  })
);
